import { Box, Flex, Text, Button } from "@chakra-ui/react";
import { useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { throttle } from "lodash";
import { useI18n } from "@/hooks/useI18n";
import { BIXIN_WALLET } from "@/helpers/constants/routeName";
import { postLoginFunc } from "./api";
import { toastTip } from "@/components/ui/toast";
import { useAppDispatch } from "@/state/hooks";
import { updateUserInfo } from "@/state/user/reducer";
import { verifyCodeVaild } from "@/utils/regexp";
import MiliCodeInput from "@/components/ui/mili-codeinput/mili-codeinput.component";

const VerifyGA = (props) => {
  const { emailInfo, password } = props;
  const { t } = useI18n();
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  const [verifyCode, setVerifyCode] = useState("");
  const [codeError, setCodeError] = useState(false);

  const passWordInputRef = useRef(null);

  const verifyCodeChange = (val) => {
    // const value = e.target.value;
    // if (codeError) {
    //   setCodeError(false);
    // }
    // setVerifyCode(value);

    if (val) {
      setVerifyCode(val);
      setCodeError(false);
    } else {
      setCodeError(true);
    }
  };

  const canSubmit = useMemo(() => {
    if (verifyCodeVaild(verifyCode)) return true;
    return false;
  }, [verifyCode]);

  const submitLogin = throttle(async () => {
    if (!verifyCodeVaild(verifyCode)) return;

    const loginRes = await postLoginFunc({
      email: emailInfo,
      loginPassword: password,
      ga_code: verifyCode,
    });

    if (loginRes.code !== 0) {
      toastTip(loginRes?.message, { type: "error" });
      // setCodeError(true);
    } else if (loginRes.code === 0) {
      localStorage.setItem("token", loginRes.data.token);
      dispatch(updateUserInfo({ userInfo: loginRes.data.user }));

      const login_redirect = localStorage.getItem("login_redirect");
      if (login_redirect) {
        navigator(login_redirect);
        return;
      }

      if (window.location.search.indexOf("?redirect_url") > -1) {
        console.log("[[ window.location.search]]", window.location.search);
        window.location.href = decodeURIComponent(
          window.location.search
        ).replace("?redirect_url=", "");
      } else {
        navigator(BIXIN_WALLET);
      }
    }
  }, 2000);

  return (
    <div>
      <Flex justifyContent={"center"} mt={["100px", "200px"]}>
        <Box w={["80%", "400px"]}>
          <Text fontSize="32px" fontWeight={"600"} color="t.100">
            {t("rtVWmSuAATyCaNgkRNx")}
          </Text>
          <Text fontSize="16px" color="t.100" mt="50px" fontWeight={700}>
            {t("RanmaYSsbuhHoMFSNO")}
          </Text>
          <Text fontSize="14px" color="t.100" mt="20px">
            {t("ltXrglJnxfNqZDSStFq")}
          </Text>
          <Flex
            mt="5px"
            justifyContent={"space-between"}
            flexDirection={"column"}
            gap="5px"
          >
            {/* <Input
              h="44px"
              borderRadius={"12px"}
              placeholder={t("cTlSqXgGENkCAQQJCHx")}
              fontSize="12px"
              type="email"
              w={["100%"]}
              _placeholder={{ color: "t.50" }}
              onChange={verifyCodeChange}
              isInvalid={codeError}
              bg={codeError ? "red.50" : "none"}
              errorBorderColor="red.100"
            /> */}
            <MiliCodeInput
              ref={passWordInputRef}
              onChange={verifyCodeChange}
              type="password"
              codeboxItemADDClassName="changeBackGround"
            />
            {/* {codeError && (
              <Text color="red.100" fontSize="12px" mt="5px">
                {t("OBIAENcRtoPgMWcJNZ")}
              </Text>
            )} */}
          </Flex>

          <Flex
            justifyContent={"center"}
            mt="30px"
            alignItems={"center"}
            fontSize="12px"
          >
            <Button
              borderRadius={"20px"}
              w="100%"
              h="44px"
              fontSize="14px"
              color="#fff"
              // mt="50px"
              onClick={submitLogin}
              _hover={{ bg: canSubmit ? "blue.80" : "t,50" }}
              cursor={canSubmit ? "pointer" : "not-allowed"}
              bg={canSubmit ? "blue.100" : "t.50"}
            >
              {t("YChcfaxDaLscdSPiRQz")}
            </Button>
          </Flex>
        </Box>
      </Flex>
    </div>
  );
};

export default VerifyGA;
